module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"edit":"Редактировать"},"en":{"edit":"Edit"}}')
  delete Component.options._Ctor
}
